/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as serviceEndPoint from '../../services/service';

export const getLabelerList = async (values) => {
  try {
    const response = await axios.get(
      serviceEndPoint.GET_ALL_LABELER_LIST,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response;
      // eslint-disable-next-line no-else-return
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
export const searchNDCByIDORDrugName = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response;
      // eslint-disable-next-line no-else-return
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getNDCByLabeller = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_UPDATED_NDC_LIST_BY_LABELER,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
      // eslint-disable-next-line no-else-return
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
